import { State } from "@/store/modules/gameKiller/index";

const setGameKillerData = (state: State, payload: any) => {
    //const data = [...state.data, ...payload];
    state.data = payload;
};

const setGameKillerTimerVote = (state: State, payload: any) => {
    state.timerVote = payload;
};

const setGameKillerTimerReport = (state: State, payload: any) => {
    state.timerReport = payload;
};

const setGameKillerUserVoted = (state: State, payload: any) => {
    state.userVoted = payload;
};

const setGameKillerTimerKiller = (state: State, payload: any) => {
    state.timerKiller = payload;
};

const setGameKillerLastDead = (state: State, payload: any) => {
    state.lastDead = payload;
};

const setGameKillerTimerBan = (state: State, payload: any) => {
    state.timerBan = payload;
};

export default {
    setGameKillerData,
    setGameKillerTimerVote,
    setGameKillerTimerReport,
    setGameKillerUserVoted,
    setGameKillerTimerKiller,
    setGameKillerLastDead,
    setGameKillerTimerBan,
};